import React, { SVGProps } from 'react'

export const HouseSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#2E2A29" clipPath="url(#a)">
      <path d="M20.76 15.757c-.742-1.485-2.865-1.471-3.589.023l-1.297 2.706a1 1 0 0 1-1.776-.054L8.902 7.594a1 1 0 0 0-1.803 0L1.902 18.432a1 1 0 0 1-1.803-.865L5.295 6.73a2.964 2.964 0 0 1 2.719-1.703L8 5h8.364a2 2 0 0 1 1.789 1.106c1.908 3.815 3.833 7.63 5.742 11.447a1 1 0 1 1-1.79.894l-1.345-2.69Z" />
      <path d="M6 15a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0v-2Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
